<template>
    <div>
        <h3>CMS</h3>
        <div><b-button class="backButton" v-on:click="toggleTemplates">Edycja szablonów</b-button></div>
        <TemplatesCMS v-show="showTemplates" v-bind:dbTemplates="templates" v-bind:userData="userData" :key="templatesKey" v-on:shutMessages="closeTemplates"/>
        <div v-if="postAdded">{{information}}</div>
        <div><b-button class="backButton" v-on:click="toggleAlertLevels">Edycja poziomów alertu</b-button></div>
        <AlertLevelCMS v-show="showAlertLevels" v-bind:dbLevels="levels" :key="levelsKey" v-on:shutLevels="closeLevels"/>
        <div v-if="levelAdded">{{information}}</div>
        <div><b-button class="backButton" v-on:click="toggleTargetGroups">Edycja grup docelowych</b-button></div>
        <TargetGroupCMS v-show="showTargetGroups" v-bind:userData="userData" v-bind:dbGroups="groups" v-bind:dbUsers="groupUsers" :key="groupsKey" v-on:shutGroups="closeGroups"/>
        <div v-if="groupAdded">{{information}}</div>
        <div><b-button class="backButton" v-on:click="toggleUsers">Edycja pracowników</b-button></div>
        <UsersCMS v-show="showUsers" v-bind:dbUsers="users" :key="usersKey" v-on:shutUsers="closeUsers" v-bind:userData="userData"/>
        <div v-if="userAdded">{{information}}</div>
        <div><b-button class="backButton" v-on:click="toggleLogins">Użytkownicy</b-button></div>
        <LoginsCMS v-show="showLogins" v-bind:userData="userData" v-bind:dbLogins="logins" :key="loginsKey" v-on:shutLogins="closeLogins"/>
        <div v-if="loginAdded">{{information}}</div>
        <UserList v-bind:userData="userData"/>
        <LogsList v-bind:userData="userData"/>
        <div><b-button class="backButton" v-on:click="returnToMainApp">WRÓĆ</b-button></div>
    </div>
</template>

<script>
import axios from 'axios';
import AlertLevelCMS from './CMScomponents/AlertLevelCMS';
import TemplatesCMS from './CMScomponents/TemplatesCMS';
import TargetGroupCMS from './CMScomponents/TargetGroupCMS';
import UsersCMS from './CMScomponents/UsersCMS';
import LoginsCMS from './CMScomponents/LoginsCMS';
import {path} from '../../config';
import UserList from '../functions/UserList';
import LogsList from '../functions/LogsList';
export default {
    name: 'CMS',
    components: {
        AlertLevelCMS,
        TemplatesCMS,
        TargetGroupCMS,
        UsersCMS,
        LoginsCMS,
        UserList,
        LogsList,
    },
    props: {
        userData: Object,
    },
    methods: {
        returnToMainApp: function() {
            this.$emit('returnFromCMS')
            this.showTemplates = false;
            this.showAlertLevels = false;
            this.showTargetGroups = false;
        },
        toggleTemplates: async function() {
            await axios
            .get(`${path}templates`)
            .then(response => (
                this.templates = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await this.rerender()
            this.showTemplates = !this.showTemplates;
            this.postAdded = false;
        },
        toggleAlertLevels: async function() {
            await axios
            .get(`${path}levels`)
            .then(response => (
                this.levels = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await this.rerender()
            this.showAlertLevels = !this.showAlertLevels;
            this.levelAdded = false;
        },
        toggleUsers: async function(){
            await axios
            .get(`${path}users`)
            .then(response => (
                this.users = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await this.rerender()
            this.showUsers  = !this.showUsers;
            this.userAdded = false;
        },
        toggleTargetGroups: async function() {
            await axios
            .get(`${path}groups`)
            .then(response => (
                this.groups = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await axios
            .get(`${path}users`)
            .then(response => (
                this.groupUsers = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await this.rerender()
            this.showTargetGroups = !this.showTargetGroups;
            this.groupAdded = false;
        },
        toggleLogins: async function(){
            await axios
            .get(`${path}login/db`)
            .then(response => (
                this.logins = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await this.rerender()
            this.showLogins  = !this.showLogins;
            this.loginAdded = false;
        },
        rerender: function() {
            this.templatesKey += 1;
            this.levelsKey += 1;
            this.groupsKey += 1;
            this.usersKey += 1;
            this.loginsKey += 1;
        },
        closeTemplates: function(info) {
            this.showTemplates = false;
            this.information = info;
            this.postAdded = true;
        },
        closeLevels: function(info) {
            this.showAlertLevels = false;
            this.information = info;
            this.levelAdded = true;
        },
        closeUsers: function(info) {
            this.showUsers = false;
            this.information = info;
            this.userAdded = true;
        },
        closeGroups: function(info) {
            this.showTargetGroups = false;
            this.information = info;
            this.groupAdded = true;
        },
        closeLogins: function(info){
            this.showLogins = false;
            this.information = info;
            this.loginAdded = true;
        }
    },
    data: function() {
        return{
            showTemplates: false,
            showAlertLevels: false,
            showTargetGroups: false,
            showUsers: false,
            showLogins: false,
            templates: '',
            levels: '',
            users: '',
            logins: '',
            groupUsers: '',
            groups: '',
            templatesKey: 0,
            levelsKey: 1,
            groupsKey: 2,
            usersKey: 3,
            loginsKey: 4,
            postAdded: false,
            levelAdded: false,
            userAdded: false,
            groupAdded: false,
            loginAdded: false,
            information: '',
        }
    }
}
</script>

<style lang="scss" scoped>
    .backButton {
        height: 50px;
        width: 90%;
        font-size: 20px;
        background-color: blue;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(40, 110, 214);
        }
        &:focus{
            background-color: blue;
            border: none;
            box-shadow: none;
        }
    }
</style>